import React from 'react';
import {
  SaveButton,
  CREATE,
  UPDATE,
  fetchEnd,
  fetchStart,
  showNotification,
  refreshView
} from 'react-admin';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';

import dataProvider from '../../core/providers/IccUserDataProvider';
import DialogTitleWithCloseButton from '../../core/components/DialogTitleWithCloseButton';
import SubcategoryForm from './SubcategoryForm';
import { getIcError } from '../../core/providers/utils';

class SubcategoryCreateDialog extends React.Component {
  subcategoryFormProps;

  state = {
    submitting: false
  };

  setSubcategoryFormProps = props => {
    this.subcategoryFormProps = props;
  };

  handleSaveClick = event => {
    // Trigger a submit of our custom quick create/update form
    // This is needed because our modal action buttons are oustide the form
    this.subcategoryFormProps.form.submit(event);
  };

  handleClose = () => {
    const { handleDialogToggle } = this.props;
    const { submitting } = this.state;
    if (submitting) return;
    this.subcategoryFormProps.form.reset();
    handleDialogToggle();
  };

  handleSubmit = values => {
    const {
      operation,
      fetchStart,
      fetchEnd,
      showNotification,
      handleDialogToggle,
      refreshView,
      categoryId
    } = this.props;
    // Dispatch an action letting react-admin know a API call is ongoing
    fetchStart();
    this.setState({ submitting: true });

    // As we want to know when the new subcategory has been created in order to close the modal, we use the
    // dataProvider directly
    const crudOperation = operation === 'Create' ? CREATE : UPDATE;
    dataProvider(crudOperation, 'subcategories', {
      data: { ...values, categoryId }
    })
      .then(() => {
        refreshView();
        handleDialogToggle();
      })
      .catch(error => {
        showNotification('ra.notification.server', 'error', {
          messageArgs: { message: getIcError(error) }
        });
      })
      .finally(() => {
        this.setState({ submitting: false });
        // Dispatch an action letting react-admin know a API call has ended
        this.subcategoryFormProps.form.reset();
        fetchEnd();
      });
  };

  render() {
    const {
      operation,
      showDialog,
      popupTitle,
      okButtonLabel,
      refreshView,
      subcategoryId,
      categoryId,
      ...rest
    } = this.props;
    const { submitting } = this.state;

    return (
      <Dialog
        fullWidth
        open={showDialog}
        aria-label={`${operation} new Subcategory`}
        maxWidth="sm"
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return null;
          this.handleClose();
        }}
      >
        <DialogTitleWithCloseButton onClose={this.handleClose}>
          {popupTitle}
        </DialogTitleWithCloseButton>
        <DialogContent>
          <SubcategoryForm
            {...rest}
            operation={operation}
            setSubcategoryFormProps={this.setSubcategoryFormProps}
            handleSubmit={this.handleSubmit}
            id={subcategoryId}
            categoryId={categoryId}
          />
        </DialogContent>
        <DialogActions>
          <SaveButton
            style={{ minWidth: '82px' }}
            saving={submitting}
            handleSubmitWithRedirect={this.handleSaveClick}
            label={okButtonLabel}
            icon={<></>}
          />
          <Button
            onClick={this.handleClose}
            variant="outlined"
            color="primary"
            disabled={submitting}
            disableFocusRipple
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = {
  fetchEnd,
  fetchStart,
  showNotification,
  refreshView
};

export default connect(null, mapDispatchToProps)(SubcategoryCreateDialog);
